export const getStatusText = status => {
  switch (status?.toLowerCase()) {
    case 'live':
      return 'LIVE'
    case 'soon':
      return 'SOON'
    case 'completed':
      return 'COMPLETED'
    case 'canceled':
      return 'CANCELED'
    default:
      return 'UNKNOWN'
  }
}

export const getStatusColor = status => {
  switch (status?.toLowerCase()) {
    case 'live':
      return '#ff4444'
    case 'soon':
      return '#ffa900'
    case 'completed':
      return '#666'
    case 'canceled':
      return '#ff4444'
    default:
      return '#666'
  }
}
